import React, { PureComponent, Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { importMapboxDependencies } from './SearchMap.helpers';
// this component relies on some global styles in this file that need to be
// turned into proper local css modules at some point
import '../Search.scss';

export class VenueMapMarker extends PureComponent {
  state = {
    loaded: false,
  };

  componentDidMount() {
    if (__CLIENT__) {
      importMapboxDependencies().then(({ ReactMapGL: { Marker } }) => {
        this.Marker = Marker;
        this.setState({ loaded: true });
      });
    }
  }

  handleOnClick = studio => {
    const { onMarkerSelected } = this.props;
    if (onMarkerSelected) {
      onMarkerSelected(studio);
    }
  };

  renderVenues = studio => {
    const { Marker } = this;
    const { highlightedVenueId, popupId } = this.props;
    const isMarkerActive = studio.id === highlightedVenueId || studio.id === popupId;

    // TODO: When migrating to CSS modules, please add a data-qa attribute for active vs. inactive marker.
    return (
      <Marker
        latitude={studio.location.lat}
        longitude={studio.location.lon}
        key={studio.id}
        className={classNames({ 'search-result-map__elevated-venue-map-marker': isMarkerActive })}>
        <div
          className={classNames('search-result-map__venue-map-marker', {
            'search-result-map__venue-map-marker--active': isMarkerActive,
          })}
          onClick={() => this.handleOnClick(studio)}
        />
      </Marker>
    );
  };

  render() {
    const { venues } = this.props;
    const { loaded } = this.state;

    return loaded && <Fragment>{venues.map(this.renderVenues)}</Fragment>;
  }
}

VenueMapMarker.propTypes = {
  venues: PropTypes.array.isRequired,
  onMarkerSelected: PropTypes.func,
  highlightedVenueId: PropTypes.number,
  popupId: PropTypes.number,
};
